import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import PatolojiNumuneKabulAramaKriterleri from "./PatolojiNumuneKabulAramaKriterleri";
import VwPatolojiRaporislemleriDTO from "src/models/PatolojiModul/VwPatolojiRaporislemleriDTO";

interface IPatolojiRaporIslemleri {
    searchHandler?: boolean;
    aramaKriterleri?: PatolojiNumuneKabulAramaKriterleri;
    activeRow: VwPatolojiRaporislemleriDTO;
    topluMail: boolean;
    open: boolean;
};
export const PatolojiRaporIslemleriSlice = createSlice<IPatolojiRaporIslemleri, MapReducerPayloads<IPatolojiRaporIslemleri, {
    setSearchHandler?: boolean;
    setAramaKriterleri?: PatolojiNumuneKabulAramaKriterleri;
    setActiveRow?: VwPatolojiRaporislemleriDTO;
    setTopluMail: boolean;
    setOpen: boolean;
}>>({
    name: "patolojiRaporIslemleri",
    initialState: {
        searchHandler: true,
        aramaKriterleri: new PatolojiNumuneKabulAramaKriterleri(),
        activeRow: new VwPatolojiRaporislemleriDTO(),
        topluMail: false,
        open: false,
    },
    reducers: {
        //Arama kriterlerini doldurduktan sonra api ye gidip veriyi çektiği state
        setSearchHandler: (state, action) => {
            state.searchHandler = action.payload
        },
        //Arama kriterlerinin tutulduğu state
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },
        setTopluMail: (state, action) => {
            state.topluMail = action.payload
        },
        setOpen: (state, action) => {
            state.open = action.payload
        },
    }
});